import { Box, Button, Tooltip } from "@mui/material";
import Header from "../../components/Header";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";

function NftCollectionDetail() {
  const collectionId = useParams();
  const navigate = useNavigate();
  const [collectionNftsDetails, setCollectionNftsDetails] = useState([]);
  const [isCopy, setIsCopy] = useState(false);
  const [auToFetchData, setAuToFetchData] = useState(false);

  function saveToClipboard(url) {
    navigator.clipboard.writeText(url);
    setIsCopy(true);
  }
  function handleHover() {
    setIsCopy(false);
  }
  async function onload() {
    try {
      await axios
        .get(
          `${process.env.REACT_APP_BASE_URL}/api/nft-minting/nfts-details?collectionId=${collectionId.id}`,
          {
            headers: {
              "content-type": "application/json",
              token: localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          if (response.data.status) {
            setAuToFetchData(false);
            let filtereddata = response.data.nftsDetail;
            let count = 0;
            filtereddata = filtereddata.map((ele) => {
              count++;
              return { ...ele, id: count };
            });
            setCollectionNftsDetails(filtereddata);
          }
        });
    } catch (error) {
      swal({
        text: "Something Went Wrong!",
        icon: "error",
      });
    }
  }

  async function handleDelete(nftDetails) {
    swal("Are you sure!", `Do you want to delete your NFT details`, "warning", {
      buttons: ["Cancel", "OK"],
    }).then(async (value) => {
      if (value) {
        await axios
          .delete(
            `${process.env.REACT_APP_BASE_URL}/api/nft-minting/collection/nft-detail?collectionId=${collectionId.id}&nftId=${nftDetails.nftId}`,
            {
              headers: {
                "content-type": "application/json",
                token: localStorage.getItem("token"),
              },
            }
          )
          .then(async (response) => {
            if (response.data.status === true) {
              setAuToFetchData(true);
              swal(
                "Deleted!",
                `Your NFT details is successfully deleted.`,
                "success",
                {
                  button: "OK",
                }
              );
            } else {
              swal("Something went wrong!", ``, "error", {
                button: "OK",
              });
            }
          })
          .catch((err) => {
            swal({
              text: err.response.data.errorMessage,
              icon: "error",
              // type: "error"
            });
          });
      }
    });
  }
  useEffect(() => {
    onload();
  }, [auToFetchData]);

  const columns = [
    {
      field: "id",
      headerName: "ID",
      flex: 0.5,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "url",
      headerName: "URL",
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Tooltip
            className="addButton"
            fontSize="large"
            title={isCopy ? "Copied" : "Copy link"}
          >
            <ContentCopyIcon
              onMouseLeave={handleHover}
              onClick={() =>
                saveToClipboard(collectionNftsDetails[cellValues.id - 1].url)
              }
            />
          </Tooltip>
        );
      },
    },

    {
      field: "edit",
      headerName: "Edit",
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Button
            className="custom-color-button"
            endIcon={<EditIcon />}
            type="submit"
            size="small"
            variant="contained"
            color="info"
            sx={{
              mt: 3,
              mb: 2,
              backgroundColor: "rgb(0, 104, 74)",
              fontFamily: "Poppins",
            }}
            onClick={() => {
              navigate("edit-nft", {
                state: collectionNftsDetails[cellValues.id - 1],
              });
            }}
          >
            Edit
          </Button>
        );
      },
    },
    {
      field: "delete",
      headerName: "Delete",
      flex: 1,
      align: "center",
      headerAlign: "center",

      renderCell: (cellValues) => {
        return (
          <Button
            endIcon={<DeleteIcon />}
            type="submit"
            size="small"
            variant="contained"
            color="error"
            sx={{ mt: 3, mb: 2, fontFamily: "Poppins" }}
            onClick={() =>
              handleDelete(collectionNftsDetails[cellValues.id - 1])
            }
          >
            Delete
          </Button>
        );
      },
    },
  ];
  return (
    <Box m="20px">
      <div style={{ display: "inline-block" }}>
        <Header
          title="Configure"
          subtitle="Click on the Add Configuration button to add new configuration"
        />
      </div>
      <Button
        className="custom-color-button"
        color="info"
        sx={{
          backgroundColor: "#6870fa",
          float: "right",
          marginTop: "10px",
          fontSize: "15px",
        }}
        variant="contained"
        startIcon={<AddIcon />}
        onClick={() => {
          navigate("add-nft");
        }}
      >
        Add Configuration
      </Button>
      <Box
        height="60vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
            fontSize: 15,
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
            fontSize: 13.5,
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "rgb(0, 104, 74)",
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: "white",
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer": {
            marginBottom: "10px",
          },
          "& .MuiDataGrid-cell:focus-within": {
            outline: `none !important`,
          },

          "& .MuiDataGrid-cellContent": {
            color: "rgb(0, 30, 43)",
            fontFamily: "Poppins",
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: "white !important",
            boxShadow:
              "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
          },

          "& .MuiDataGrid-columnSeparator": {
            display: "none !important",
          },
          "& .MuiDataGrid-main": {
            boxShadow:
              "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
          },
          "& .MuiDataGrid-menuIcon": {
            color: "white",
          },
        }}
      >
        <DataGrid
          rows={collectionNftsDetails}
          columns={columns}
          getRowId={(row) => row.id}
          components={{ Toolbar: GridToolbar }}
          pageSize={5}
          rowsPerPageOptions={[5, 10, 20]}
          md={12}
          sm={12}
          xs={12}
        />
      </Box>
    </Box>
  );
}

export default NftCollectionDetail;
